import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useSignout } from '../hooks/react-query/useSignIn';

import { Header } from './header/header';
import { useLocation } from 'react-router-dom';
import { MenuBar } from './menuBar/MenuBar';
import usePersonStore from '../store/personStore';
import Loader from '../components/elements/loader';

// let userRole = 'retailUser';

const Layout = () => {
  const navigate = useNavigate();

  const { mutate: logout, isLoading: isLogoutLoding } = useSignout();

  const showRetailDashboard = usePersonStore(
    (store) => store.showRetailDashboard
  );

  const location = useLocation();
  const { pathname } = location;

  const [hasOnlyDriversRole, setDriverRole] = useState(false);
  const [impersonateUser, setImpersonateUser] = useState(false);

  const assignedRoles = usePersonStore((store) => store.userRoles);

  useEffect(() => {
    const isPersonate = localStorage.getItem('adminJWT');
    const isGroupPersonate = localStorage.getItem('fleetAdminJWT');
    setImpersonateUser(isPersonate || isGroupPersonate);
  }, [location]);

  useEffect(() => {
    if (assignedRoles && assignedRoles.length) {
      const hasDriversRole =
        assignedRoles.length === 1 && assignedRoles.includes('driver');
      setDriverRole(hasDriversRole);
    }
  }, [assignedRoles]);

  const handleLogout = () => {
    logout({
      onSuccess: () => {
        navigate('/');
      },
    });
  };

  const navigateToDashboard = () => {
    if(assignedRoles.length > 0 && !pathname.includes('/dashboard'))
     navigate('/dashboard');
  };

  return (
    <div className="flex flex-col h-screen relative">
      {isLogoutLoding && <Loader className="fill-primary" />}
      <Header
        impersonateUser={impersonateUser}
        handleLogout={handleLogout}
        handleDasboardClick={navigateToDashboard}
      />

      <div className="flex flex-col max-lg:flex-col-reverse h-full">
        <main
          className={`w-full h-full overflow-auto scrollbar`}
          style={{
            background: "url('/bg-dashboard.svg')",
            backgroundSize: 'cover',
          }}
        >
          <Outlet />
        </main>
        {showRetailDashboard && !pathname.includes('track-your-car') && (
          <MenuBar hasOnlyDriversRole={hasOnlyDriversRole} />
        )}
      </div>
    </div>
  );
};

export default Layout;
